import { Button, ButtonSize, ButtonVariant, DropDownMenu, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { cn } from "@/utils";

interface ILanguageDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  languages: string[];
  languageCodes?: string[];
  error?: boolean;
  placeholder: string;
  helperText: string;
  isLoading?: boolean;
  "data-testid"?: string;
}

const dropdownMenuStyles = {
  width: "100%",
  minWidth: "100%",
};
const languagesButtonClassNames = {
  text: "!text-left !justify-start flex-1",
};

export function LanguageDropdown({
  value,
  onChange,
  languages,
  languageCodes,
  error,
  placeholder,
  helperText,
  isLoading = false,
  "data-testid": testId = "LanguageDropdown",
}: ILanguageDropdownProps) {
  const codes = languageCodes || languages;

  const listItems = languages.map((language, index) => ({
    value: codes[index],
    label: language,
    onPress: () => {
      if (onChange) {
        onChange(codes[index]);
      }
    },
  }));

  const selectedIndex = codes.findIndex((code) => code === value);
  const currentValue = selectedIndex >= 0 ? languages[selectedIndex] : placeholder;
  const isPlaceholder = selectedIndex < 0;

  return (
    <div className="flex flex-col" data-testid={testId}>
      <div className="w-full">
        <DropDownMenu
          placement="bottom-start"
          listItems={listItems}
          className="left-0"
          DropDownMenuStyles={dropdownMenuStyles}
          isListLoading={isLoading}
        >
          <Button
            data-testid="LanguageDropdown-TriggerButton"
            iconStart={IconVariants.LANGUAGES}
            iconEnd={IconVariants.CHEVRON_DOWN}
            variant={ButtonVariant.OUTLINED}
            size={ButtonSize.MEDIUM}
            aria-label={currentValue}
            className={cn("w-full h-[44px] !justify-between", error && "ring-2 ring-red-9 ring-inset")}
            classNames={languagesButtonClassNames}
          >
            <Text variant={TextVariants.LABEL_MEDIUM_REGULAR} className={`!text-left ${isPlaceholder ? "text-gray-11" : ""}`}>
              {currentValue}
            </Text>
          </Button>
        </DropDownMenu>
      </div>
      {error ? (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-left mt-1 text-gray-11">
          {helperText}
        </Text>
      ) : null}
    </div>
  );
}

export default LanguageDropdown;
